export const getVariablesHSM = (body) => {
  const variables = [];
  const regex = /{{\d}}/g;
  const result = body.match(regex);
  if (result) {
    result.forEach((item) => {
      if (!variables.includes(item)) {
        variables.push(item);
      }
    });
  }
  return variables;
};
